import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "edit-user-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12 mb-20" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-md-6 mb-20" }
const _hoisted_11 = { class: "col-md-6 mb-20" }
const _hoisted_12 = { class: "col-12 mb-20" }
const _hoisted_13 = { class: "badge bg-primary" }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "col-md-6 mb-20" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "col-md-6 mb-20" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = { class: "col-md-6 mb-20" }
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "col-md-6 mb-20" }
const _hoisted_23 = { class: "col-md-6 mb-20" }
const _hoisted_24 = { class: "col-md-6 mb-20" }
const _hoisted_25 = { class: "col-12 mb-20" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "col-12 mb-20" }
const _hoisted_28 = { class: "col-md-6 mb-20" }
const _hoisted_29 = { class: "col-md-6 mb-20" }
const _hoisted_30 = { class: "col-md-6 mb-20" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "col-md-6 mb-20" }
const _hoisted_33 = { class: "col-md-6 mb-20" }
const _hoisted_34 = { class: "col-md-6 mb-20" }
const _hoisted_35 = { class: "d-flex align-items-center gap-3 mt-2" }
const _hoisted_36 = ["id", "value"]
const _hoisted_37 = ["for"]
const _hoisted_38 = { class: "col-md-4 mb-20" }
const _hoisted_39 = { class: "col-md-4 mb-20" }
const _hoisted_40 = { class: "col-md-4 mb-20" }
const _hoisted_41 = { class: "col-md-4 mb-20" }
const _hoisted_42 = { class: "col-md-4 mb-20" }
const _hoisted_43 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-20" }
const _hoisted_44 = {
  type: "submit",
  class: "btn btn-success px-4 py-2"
}
const _hoisted_45 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2"
}
const _hoisted_46 = {
  class: "tab-pane fade",
  id: "city-fees-tab",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_47 = { class: "card p-4 mt-20" }
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = { class: "mb-3" }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = { class: "col-md-2" }
const _hoisted_52 = { class: "mb-3" }
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = { class: "col-md-2" }
const _hoisted_55 = { class: "mb-3" }
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = { class: "col-md-4 d-flex align-items-end mb-3" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "col-md-5" }
const _hoisted_60 = ["onUpdate:modelValue", "onInput"]
const _hoisted_61 = ["value"]
const _hoisted_62 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_63 = { class: "col-md-3" }
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = ["onUpdate:modelValue", "disabled"]
const _hoisted_67 = { class: "col-md-1 d-flex align-items-end" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  class: "tab-pane fade",
  id: "contact-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_70 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_71 = { class: "mb-3" }
const _hoisted_72 = { class: "form-label" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_75 = { class: "mb-3" }
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-4" }
const _hoisted_79 = {
  class: "tab-pane fade",
  id: "permissions-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-lg-12" }
const _hoisted_82 = { class: "card mb-25 border-0 rounded-0 bg-white to-do-list-box" }
const _hoisted_83 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_84 = { class: "to-do-list ps-0 list-unstyled mb-0" }
const _hoisted_85 = { class: "to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between" }
const _hoisted_86 = { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium" }
const _hoisted_87 = ["checked"]
const _hoisted_88 = { class: "to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between" }
const _hoisted_89 = { class: "form-check form-check-warning mb-0 fs-md-15 fs-lg-16 text-black fw-medium" }
const _hoisted_90 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[74] || (_cache[74] = _createElementVNode("ul", {
        class: "nav nav-tabs",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "edit-user-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#edit-user-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "edit-user-tab-pane",
            "aria-selected": "true"
          }, " Informations Générales ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "profile-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#city-fees-tab",
            type: "button",
            role: "tab",
            "aria-controls": "city-fees-tab",
            "aria-selected": "false"
          }, " Personnaliser les frais d'une ville ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "contact-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#contact-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "contact-tab-pane",
            "aria-selected": "false"
          }, " Personnaliser les frais ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "permissions-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#permissions-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "permissions-tab-pane",
            "aria-selected": "false"
          }, " Permissions ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
            class: "mt-40"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de profil ", -1)),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.imagepreview)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imagepreview,
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/images/NoImage.png'),
                        class: "rounded-circle me-15",
                        style: {"width":"90px","height":"90px","object-fit":"cover"}
                      }, null, 8, _hoisted_9)),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      ref: "updateImgInput",
                      type: "file",
                      accept: "image/*",
                      class: "d-none",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                    }, null, 544),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary me-2",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                    }, " Choisir la photo "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                    }, " Annuler ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customerData.name) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Nom complet",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.customerData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "CIN *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customerData.cin) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "CIN",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.customerData.cin]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "(Pièces Jointes) CIN *", -1)),
                _createElementVNode("input", {
                  type: "file",
                  class: "form-control shadow-none rounded-0",
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fileSelected && _ctx.fileSelected(...args))),
                  multiple: "",
                  accept: "image/*"
                }, null, 32),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "mt-2"
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(attachment.name) + " (" + _toDisplayString((attachment.size / 1024 / 1024).toFixed(1)) + "MB) ", 1)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (url, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: index,
                      src: url,
                      class: "me-2 mb-2",
                      style: {"width":"120px","height":"120px","object-fit":"cover"}
                    }, null, 8, _hoisted_15))
                  }), 128)),
                  (_ctx.urls.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-warning rounded-circle",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeFiles && _ctx.removeFiles(...args)))
                      }, " X "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse electronique *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customerData.email) = $event)),
                  type: "email",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Adresse electronique",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.customerData.email]
                ]),
                (_ctx.erroremail)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_17, "Email éléctronique déja existe"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du magasin *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.customerData.store) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Nom du magasin",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.customerData.store]
                ]),
                (_ctx.errorstore)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_19, "Magazin déja existe"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro de téléphone *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.customerData.phone) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Numéro de téléphone",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.customerData.phone]
                ]),
                (_ctx.errorphone)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_21, "Ce numéro téléphone déja existe"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[39] || (_cache[39] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Numéro de téléphone (Personnel)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.customerData.phone_personal) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Numéro de téléphone (Personnel)"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.phone_personal]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[40] || (_cache[40] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customerData.password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Mot de passe"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.password]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Confirmation de mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customerData.c_password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Confirmation de mot de passe"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.c_password]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[42] || (_cache[42] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Ville *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customerData.city_id) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citiesList, (c, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: c.id
                    }, _toDisplayString(c.name), 9, _hoisted_26))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.customerData.city_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[43] || (_cache[43] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Adresse *", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customerData.adresse) = $event)),
                  rows: "2",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Adresse",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.customerData.adresse]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[44] || (_cache[44] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Site web *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.customerData.website) = $event)),
                  type: "url",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Site web *"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.website]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[45] || (_cache[45] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Marque *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.customerData.brand) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Marque *"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.brand]
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[46] || (_cache[46] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Type d'entereprise *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.customerData.id_type) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeClients, (c, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: c.id
                    }, _toDisplayString(c.name), 9, _hoisted_31))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.customerData.id_type]
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[47] || (_cache[47] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Registre de commerce", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customerData.rc) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Registre de commerce"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.rc]
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[49] || (_cache[49] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Bloquer ajout des colis *", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.customerData.block_add_parcel) = $event)),
                  class: "form-select shadow-none rounded-0",
                  required: ""
                }, _cache[48] || (_cache[48] = [
                  _createElementVNode("option", { value: "1" }, "Oui", -1),
                  _createElementVNode("option", { value: "0" }, "Non", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.customerData.block_add_parcel]
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[50] || (_cache[50] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Message WhatsApp Meta ", -1)),
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{ label: 'Oui', value: '1' }, { label: 'Non', value: '0' }], (opt) => {
                    return _createElementVNode("div", {
                      class: "form-check form-check-inline",
                      key: opt.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        id: `wtsp_${opt.value}`,
                        value: opt.value,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.customerData.meta_wtsp_msg) = $event))
                      }, null, 8, _hoisted_36), [
                        [_vModelRadio, _ctx.customerData.meta_wtsp_msg]
                      ]),
                      _createElementVNode("label", {
                        class: _normalizeClass(["form-check-label fw-medium", opt.value === '1' ? 'text-success' : 'text-danger']),
                        for: `wtsp_${opt.value}`
                      }, _toDisplayString(opt.label), 11, _hoisted_37)
                    ])
                  }), 64))
                ])
              ]),
              _cache[58] || (_cache[58] = _createElementVNode("hr", { class: "mb-40" }, null, -1)),
              _createElementVNode("div", _hoisted_38, [
                _cache[51] || (_cache[51] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de livraison personnalisé", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control shadow-none rounded-0",
                  type: "number",
                  min: "0",
                  id: "delivered_price",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.customerData.delivered_price) = $event)),
                  placeholder: "Frais de livraison personnalisé"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.delivered_price]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[52] || (_cache[52] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de retour personnalisé", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control shadow-none rounded-0",
                  type: "number",
                  min: "0",
                  id: "returned_price",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.customerData.returned_price) = $event)),
                  placeholder: "Frais de retour personnalisé"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.returned_price]
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[53] || (_cache[53] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais de refus personnalisé", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control shadow-none rounded-0",
                  type: "number",
                  min: "0",
                  id: "refused_price",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.customerData.refused_price) = $event)),
                  placeholder: "Frais de refus personnalisé"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.refused_price]
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[54] || (_cache[54] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais Stock", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control shadow-none rounded-0",
                  type: "number",
                  min: "0",
                  id: "stock_fees",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.customerData.stock_fees) = $event)),
                  placeholder: "Frais Stock"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.stock_fees]
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[55] || (_cache[55] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Frais Pour Colis remplacé", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control shadow-none rounded-0",
                  type: "number",
                  min: "0",
                  id: "replace_fees",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.customerData.replace_fees) = $event)),
                  placeholder: "Frais colis à ramplacé"
                }, null, 512), [
                  [_vModelText, _ctx.customerData.replace_fees]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", _hoisted_44, [
                  _cache[56] || (_cache[56] = _createTextVNode(" Enregistrer ", -1)),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45))
                    : _createCommentVNode("", true)
                ]),
                _cache[57] || (_cache[57] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link text-danger"
                }, " Annuler ", -1))
              ])
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            (_ctx.citiesTarif.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.citiesTarif, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "row mb-3 border rounded p-3"
                  }, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _cache[59] || (_cache[59] = _createElementVNode("label", { class: "form-label" }, "Ville", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                          placeholder: "Ville",
                          disabled: ""
                        }, null, 8, _hoisted_50), [
                          [_vModelText, item.name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _cache[60] || (_cache[60] = _createElementVNode("label", { class: "form-label" }, "Frais", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.delivered_fees) = $event),
                          placeholder: "20",
                          disabled: ""
                        }, null, 8, _hoisted_53), [
                          [_vModelText, item.delivered_fees]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _cache[61] || (_cache[61] = _createElementVNode("label", { class: "form-label" }, "Nouveau Frais", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.n_delivered_fees) = $event),
                          placeholder: "15"
                        }, null, 8, _hoisted_56), [
                          [_vModelText, item.n_delivered_fees]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-danger",
                        onClick: ($event: any) => (_ctx.removeCity(item))
                      }, _cache[62] || (_cache[62] = [
                        _createElementVNode("i", { class: "bi bi-x-lg me-1" }, null, -1),
                        _createTextVNode(" Supprimer ", -1)
                      ]), 8, _hoisted_58)
                    ]),
                    _cache[63] || (_cache[63] = _createElementVNode("div", { class: "col-12" }, [
                      _createElementVNode("hr")
                    ], -1))
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _cache[28] || (_cache[28] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addCities && _ctx.addCities(...args)), ["prevent"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formItems, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "row mb-3 border p-2 rounded"
                }, [
                  _createElementVNode("div", _hoisted_59, [
                    _cache[65] || (_cache[65] = _createElementVNode("label", { class: "form-label" }, "Ville :", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((item.id) = $event),
                      class: "form-select shadow-none rounded-0",
                      required: "",
                      onInput: (e) => _ctx.updateItemForm(index, +(e.target as HTMLSelectElement).value)
                    }, [
                      _cache[64] || (_cache[64] = _createElementVNode("option", {
                        disabled: "",
                        value: ""
                      }, " -- Sélectionner une ville -- ", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citiesList, (c) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: c.id,
                          value: c.id
                        }, _toDisplayString(c.name), 9, _hoisted_61))
                      }), 128))
                    ], 40, _hoisted_60), [
                      [_vModelSelect, item.id]
                    ]),
                    (_ctx.errorExist.exist && _ctx.errorExist.error === index)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_62, "Ville déjà sélectionnée"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _cache[66] || (_cache[66] = _createElementVNode("label", { class: "form-label" }, "Frais", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((item.delivered_fees) = $event),
                      type: "number",
                      min: "0",
                      class: "form-control",
                      required: "",
                      disabled: ""
                    }, null, 8, _hoisted_64), [
                      [
                        _vModelText,
                        item.delivered_fees,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _cache[67] || (_cache[67] = _createElementVNode("label", { class: "form-label" }, "Nouveau Frais", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((item.n_delivered_fees) = $event),
                      type: "number",
                      min: "0",
                      step: "0.01",
                      class: "form-control",
                      required: "",
                      disabled: _ctx.errorExist.exist && _ctx.errorExist.error === index
                    }, null, 8, _hoisted_66), [
                      [
                        _vModelText,
                        item.n_delivered_fees,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    (_ctx.formItems.length > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-outline-danger",
                          onClick: ($event: any) => (_ctx.removeItem(index))
                        }, _cache[68] || (_cache[68] = [
                          _createElementVNode("i", { class: "ph-duotone ph-trash" }, null, -1)
                        ]), 8, _hoisted_68))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary me-2",
                onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
              }, _cache[69] || (_cache[69] = [
                _createElementVNode("i", { class: "ph ph-plus" }, null, -1),
                _createTextVNode(" Nouvelle ville ", -1)
              ])),
              _cache[70] || (_cache[70] = _createElementVNode("div", { class: "col-md-12 d-flex align-items-center justify-content-between mt-4" }, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-success px-4 py-2"
                }, " Enregistrer ")
              ], -1))
            ], 32)
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persoCities, (citie, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row",
              key: index
            }, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("label", _hoisted_72, " Frais de (" + _toDisplayString(citie.p_delivered_fees) + ") ", 1),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: citie.p_delivered_fees,
                    disabled: ""
                  }, null, 8, _hoisted_73)
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _cache[71] || (_cache[71] = _createElementVNode("label", { class: "form-label" }, "Nouveau Frais", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((citie.n_delivered_fees) = $event),
                    placeholder: "0"
                  }, null, 8, _hoisted_76), [
                    [_vModelText, citie.n_delivered_fees]
                  ])
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.editFess && _ctx.editFess(...args))),
                class: "btn btn-success px-4 py-2"
              }, " Enregistrer ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("ul", _hoisted_84, [
                    _createElementVNode("li", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("input", {
                          class: "form-check-input shadow-none",
                          type: "checkbox",
                          id: "task1",
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.permStock())),
                          checked: _ctx.permsCust.stock == 1
                        }, null, 8, _hoisted_87),
                        _cache[72] || (_cache[72] = _createElementVNode("label", {
                          class: "form-check-label d-flex align-items-center",
                          for: "task1"
                        }, " Stock Client ", -1))
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("input", {
                          class: "form-check-input shadow-none",
                          type: "checkbox",
                          id: "task5",
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.permAddParcel())),
                          checked: _ctx.permsCust.Parcels == 1
                        }, null, 8, _hoisted_90),
                        _cache[73] || (_cache[73] = _createElementVNode("label", {
                          class: "form-check-label d-flex align-items-center",
                          for: "task5"
                        }, " Ajout des Colis ", -1))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}